import { RouteConfig } from "vue-router";
import { safeImport } from "@/utils/SafeImport";

const routes: readonly RouteConfig[] = [
  {
    path: "/",
    name: "login",
    component: safeImport(
      () => import(/* webpackChunkName: "route.login" */ "../views/Login.vue")
    ),
    meta: {
      redirectWhenAuthenticated: true,
    },
  },
  {
    path: "/callback",
    name: "login_callback",
    component: safeImport(
      () =>
        import(
          /* webpackChunkName: "route.login-callback" */ "../views/LoginCallback.vue"
        )
    ),
  },
  {
    path: "/join/:token",
    name: "app_invitation",
    component: safeImport(
      () =>
        import(
          /* webpackChunkName: "route.first-login" */ "../views/FirstLogin.vue"
        )
    ),
  },
];

export default routes;
